var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process-record" }, [
    _c("div", { staticClass: "title" }, [_vm._v("流程追踪")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "process-record-item-list" },
      _vm._l(_vm.datas, function (e, i) {
        return _c("span", { key: i }, [
          e.state !== 3
            ? _c("div", { staticClass: "process-record-item" }, [
                _c("div", { staticClass: "time" }, [
                  _c("p", [_vm._v(_vm._s(e.startDate || "-"))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(e.endDate || "-"))]),
                ]),
                _vm._v(" "),
                _vm._m(0, true),
                _vm._v(" "),
                _c("div", { staticClass: "message" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("环节：" + _vm._s(e.orderLinkName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base" },
                    [
                      _c(
                        "el-row",
                        { staticClass: "message__container" },
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _vm._v("处理人：" + _vm._s(e.submitter || "-")),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _vm._v("操作：" + _vm._s(e.operationType || "-")),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _vm._v(
                              "用时：" +
                                _vm._s(
                                  _vm.getInterValDay(e.endDate, e.startDate)
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _vm._v("意见：" + _vm._s(e.remark || "-")),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-container" }, [
      _c("span", { staticClass: "round" }),
      _vm._v(" "),
      _c("span", { staticClass: "line" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }